import './blocks/counter-control';
import './blocks/icons-control';
import './blocks/progress-control';
import './blocks/minus-support';
import './blocks/position';
